export interface LogoConfig {
  src: string | string[];
  alt: string;
  label?: string;
  labelFont?: string;
  className?: string;
  additionalClasses?: string;
}

export const INTEGRATION_LOGOS: LogoConfig[] = [
  {
    src: "/media/apple-wallet-seeklogo.png",
    alt: "Apple Wallet",
    label: "Apple Wallet",
    labelFont: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", sans-serif'
  },
  {
    src: "/media/google-wallet.svg",
    alt: "Google Wallet"
  },
  {
    src: ["/media/Canva Icon logo.svg", "/media/Canva type logo.svg"],
    alt: "Canva"
  },
  {
    src: "/media/dotypos.png",
    alt: "Dotypos",
    additionalClasses: "invert dark:invert-0"
  },
  {
    src: "/media/Google-Maps-Logo.png",
    alt: "Google Maps"
  },
  {
    src: "/media/stripe-integration-logo.png",
    alt: "Stripe"
  }
];
